// extracted by mini-css-extract-plugin
export var container = "success-message-module--container--k2DuB";
export var content = "success-message-module--content--xg1cA";
export var titleText = "success-message-module--title-text--KjvwC";